import {
    CLOSE_PRIZE_EDITOR,
    CREATE_PRIZE_ITEM,
    DELETE_PRIZE_ITEM,
    GET_PRIZE_ITEM,
    GET_PRIZE_ITEMS,
    OPEN_PRIZE_EDITOR,
    UPDATE_EDITOR_FIELD,
    UPDATE_PRIZE_ITEM,
} from '../actions/actionTypes';
const INITIAL_STATE = {
    prizeItems: [],
    prizeItem: {},
    prizeEditor: {
        open: false,
        id: '',
    },
};

const prizeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_PRIZE_ITEM: {
            return {
                ...state,
                prizeItems: [...state.prizeItems, action.prizeItem],
            };
        }
        case GET_PRIZE_ITEM: {
            return {
                ...state,
                prizeItem: action.prize,
            };
        }
        case GET_PRIZE_ITEMS: {
            return {
                ...state,
                prizeItems: action.prizeItems,
            };
        }
        case OPEN_PRIZE_EDITOR: {
            return {
                ...state,
                prizeEditor: {
                    ...state.prizeEditor,
                    open: true,
                    id: action.id,
                },
                prizeItem: {
                    ...(!action.id ? {} : state.prizeItem),
                },
            };
        }
        case CLOSE_PRIZE_EDITOR: {
            return {
                ...state,
                prizeEditor: {
                    ...state.prizeEditor,
                    open: false,
                },
                prizeItem: {},
            };
        }
        case UPDATE_EDITOR_FIELD: {
            return {
                ...state,
                prizeItem: {
                    ...(action.field === 'prizeType' ? {} : state.prizeItem),
                    [action.field]: action.value,
                },
            };
        }
        case DELETE_PRIZE_ITEM: {
            return {
                ...state,
                prizeItem: {},
                PrizeItems: state.prizeItems.filter(
                    (item) => item.loyaltyPrizeItemId !== action.id
                ),
            };
        }
        case UPDATE_PRIZE_ITEM: {
            return {
                ...state,
                prizeItems: state.prizeItems.map((prize) =>
                    prize.loyaltyPrizeItemId ===
                    action.prizeItem.loyaltyPrizeItemId
                        ? action.prizeItem
                        : prize
                ),
            };
        }
        default: {
            return state;
        }
    }
};

export default prizeReducer;
